import './index.scss';
import {observer, inject} from 'mobx-react';
@inject(({store}) => ({
    ggwlc: store.ggwlc,
    jump: store.jump,
    ymbj: store.ymbj
}))
@observer
class Ads extends React.Component {
    render() {
        const {ggwlc, ymbj, jump} = this.props;
        if(ggwlc.length < 2 || (ymbj.ggwlc && ymbj.ggwlc.switch !== 1)) return null;
        return (
            <div className="m-ads" id="ggwlc">
                {
                    ggwlc.map((val, index) => {
                        if(index > 5) return null;
                        return <div className="item" onClick={() => {
                            val.jumpInfo && jump(val.jumpInfo.touchUrl + (val.jumpInfo.touchUrl.includes('?') ? '&' : '?') + 'type=browser');
                        }}>
                            <img src={val.img} />
                        </div>;
                    })
                }
            </div>
        );
    }
}

export default Ads;